var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',[_c('div',{staticClass:"containers"},_vm._l((_vm.storeList),function(item,index){return _c('div',{key:index,staticClass:"store"},[_c('p',{staticClass:"store_name"},[_vm._v(_vm._s(item.storeName))]),_c('p',[_vm._v(_vm._s(item.storeSite))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }